import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_JOB_LOCATION,
  GET_JOB_LOCATIONS
} from '../actions';

export function jobLocationsListReducer(state = [], action: Action) {
  switch (action.type) {
    case CREATE_JOB_LOCATION:
      return [ ...state, ...action.payload.jobLocation ].sort(sortJobLocations);
    case GET_JOB_LOCATIONS:
      return action.payload.jobLocations.sort(sortJobLocations);
    default:
      return state;
  }
}

const sortJobLocations = (a, b) => {
  return +a.timestamp - +b.timestamp;
};

export const jobLocationsReducers = combineReducers({
  jobLocationsList: jobLocationsListReducer
});


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/jobLocations.ts